const getCurrentPathWithSearch = () => {
  if (typeof window === "undefined") return "";
  return `${window.location.pathname}${window.location.search}`;
};

export const buildPathWithQueryParams = (
  params,
  pathname = typeof window !== "undefined" ? window.location.pathname : ""
) => {
  const query = params?.toString?.() || "";
  return query ? `${pathname}?${query}` : pathname;
};

export const pushInternalUrlWithoutReload = (target) => {
  if (typeof window === "undefined" || !target) return;

  if (target !== getCurrentPathWithSearch()) {
    window.history.pushState(null, "", target);
  }
};

export const pushQueryParamsWithoutReload = (params, pathname) => {
  pushInternalUrlWithoutReload(buildPathWithQueryParams(params, pathname));
};

export const getCurrentQueryParams = (fallbackSearchParams) =>
  new URLSearchParams(
    typeof window !== "undefined"
      ? window.location.search
      : fallbackSearchParams?.toString?.() || ""
  );

export const removeQueryParamWithoutReload = (key, fallbackSearchParams) => {
  const params = getCurrentQueryParams(fallbackSearchParams);
  const keys = Array.isArray(key) ? key : [key];

  keys.forEach((item) => params.delete(item));
  pushQueryParamsWithoutReload(params);
};

export const setQueryParamWithoutReload = (
  key,
  value,
  fallbackSearchParams
) => {
  const params = getCurrentQueryParams(fallbackSearchParams);
  const entries =
    typeof key === "object" && key !== null ? Object.entries(key) : [[key, value]];

  entries.forEach(([itemKey, itemValue]) => {
    if (itemValue === undefined || itemValue === null || itemValue === "") {
      params.delete(itemKey);
    } else {
      params.set(itemKey, itemValue);
    }
  });

  pushQueryParamsWithoutReload(params);
};
